import {
  OTP_TIMER,
  OTP_TIMER_DECREASE,
  VALIDATE_OTP,
} from './actions';
import { OTP_STATE } from './constants';

export const defaultState = {
  status: OTP_STATE.DEFAULT,
  resetLink: '',
  timer: {
    isLoading: true,
    isTimer: false,
    remainingSeconds: 0,
    isExpired: false,
    email: '',
    error: '',
  },
};

const reducer = (state = defaultState, action = null) => {
  switch (action.type) {
    case OTP_TIMER.BEGIN:
      return {
        ...state,
        timer: {
          ...state.timer,
          isLoading: true,
        },
      };
    case OTP_TIMER.SUCCESS:
      return {
        ...state,
        timer: {
          isTimer: true,
          isLoading: false,
          remainingSeconds: action.payload.remaining_seconds,
          isExpired: action.payload.expired,
          email: action.payload.email,
          error: action.payload.error,
        },
      };
    case OTP_TIMER.FAILURE:
      return {
        ...state,
        timer: {
          ...state.timer,
          isTimer: true,
          isLoading: false,
          email: action.payload.email || '',
        },
      };
    case OTP_TIMER_DECREASE:
      return {
        ...state,
        timer: {
          ...state.timer,
          remainingSeconds: state.timer.remainingSeconds - 1,
        },
      };
    case VALIDATE_OTP.BEGIN:
      return {
        ...state,
        status: OTP_STATE.PENDING,
      };
    case VALIDATE_OTP.SUCCESS:
      return {
        ...state,
        resetLink: action.payload.resetLink,
        status: OTP_STATE.COMPLETE,
      };
    case VALIDATE_OTP.FAILURE:
      return {
        ...state,
        status: OTP_STATE.FAILURE,
      };
    case VALIDATE_OTP.RESET:
      return defaultState;
    default:
      return state;
  }
};

export default reducer;
